module.exports = __webpack_public_path__ + "static/media/0033.e580c2b3.svg";